<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <div>LINE Pay</div>
      </f7-nav-title>
    </f7-navbar>
    <f7-block v-if="!hasConfirmed" class="content">
      <div>付款確認中...</div>
      <f7-progressbar infinite style="width: 80%;" />
    </f7-block>
    <f7-block v-else-if="failed" class="content">
      <div>LINE Pay: <span style="color: red; font-size: 24px;">付款失敗</span></div>
      訂單代號：{{ order.nickname }}
      <div>請至點餐紀錄查看訂單並<span style="color: red; font-size: 24px;">重新付款</span></div>
      <qr-code :text="this.publicIdPathParam" :size="qrCodeWidth" level="H" />
      <f7-button raised fill @click="backToMenu()">回到菜單</f7-button>
    </f7-block>
    <f7-block v-else class="content">
      訂單代號：<span style="color: red; font-size: 24px;">{{ order.nickname }}</span>
      <qr-code :text="this.publicIdPathParam" :size="qrCodeWidth" level="H" />
      <f7-button raised fill @click="backToMenu()">回到菜單</f7-button>
    </f7-block>
  </f7-page>
</template>

<script>
import { storeClient } from '@/service/apiClients'
import QrCode from '@/common/components/QrCode'

export default {
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      hasConfirmed: false,
      failed: true,
      order: null
    }
  },
  async created () {
    try {
      const { data: order } = await storeClient.get(`/stores/${this.storeIdPathParam}/orders/${this.publicIdPathParam}/client`)
      this.order = order
      await storeClient.post(`/stores/${this.storeIdPathParam}/orders/${this.publicIdPathParam}/payment/linePayOnline/after`, {
        transactionId: this.getQueryString('transactionId')
      })
      this.hasConfirmed = true
      this.failed = false
      this.$f7.dialog.alert(
        `LINE Pay 付款成功<br/>
        訂單代號：<span style="color: red; font-size: 24px;">${order.nickname}</span><br/>
        請至點餐記錄頁面查詢訂單`
      )
    } catch (e) {
      console.log(e)
      this.hasConfirmed = true
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  props: {
    storeIdPathParam: String,
    publicIdPathParam: String
  },
  computed: {
    qrCodeWidth () {
      // TODO 這邊還要經過實際測試才知道最大可以多大，目的是不要讓 qrcode 超過 scanner
      return Math.min(300, this.windowWidth * 0.5)
    }
  },
  methods: {
    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight () {
      this.windowHeight = document.documentElement.clientHeight
    },
    getQueryString (name) {
      const url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    backToMenu () {
      this.$f7router.navigate(`/stores/${this.storeIdPathParam}/menu`, {
        reloadCurrent: true
      })
    }
  },
  components: {
    QrCode
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content * {
  font-size: 18px;
  margin: 10px;
}
</style>
